import { render, staticRenderFns } from "./PartGiveItemList.vue?vue&type=template&id=abf3316c&"
import script from "./PartGiveItemList.vue?vue&type=script&lang=js&"
export * from "./PartGiveItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports